import Link from 'next/link';
import { ICaseBattleGame } from '@/utils/types/ICaseBattle';
import CopyBlock from '@/components/Modals/BattleFairness/CopyBlock';

interface Props {
    game: ICaseBattleGame;
}

const BattleFairness = ({ game }: Props) => {
    return (
        <div className="flex flex-col gap-4">
            <CopyBlock title="Battle ID" value={game.id} />
            <CopyBlock title="EOS Block Number" value={game.fairBlock} />
            <CopyBlock title="EOS Block ID" value={game.fairSeed} />
            <Link
                href={{
                    pathname: '/fairplay',
                    query: {
                        game: 'casebattles',
                        battleId: game.id,
                        block: game.fairBlock,
                        blockId: game.fairSeed,
                    },
                }}
                className="group relative overflow-hidden inline-flex items-center justify-center gap-2 px-5 py-3 rounded-fl text-white text-[12.5px] font-extrabold tracking-[0.07em] uppercase font-chat-nick hover:-translate-y-0.5 transition-transform"
                style={{
                    background: 'linear-gradient(135deg, #46e08a, #3ad6ff)',
                    boxShadow:
                        'inset 0 1px 0 rgba(255,255,255,0.35), 0 0 22px -4px rgba(70,224,138,0.65), 0 8px 20px -6px rgba(58,214,255,0.5)',
                }}
            >
                <span
                    aria-hidden
                    className="pointer-events-none absolute inset-0 -translate-x-[120%] group-hover:translate-x-[120%] transition-transform duration-[700ms] ease-out"
                    style={{
                        background:
                            'linear-gradient(100deg, transparent 30%, rgba(255,255,255,0.5), transparent 70%)',
                    }}
                />
                <svg
                    viewBox="0 0 24 24"
                    className="relative w-4 h-4 stroke-current fill-none [stroke-width:2] [stroke-linecap:round] [stroke-linejoin:round]"
                >
                    <path d="M12 3l9 4v6c0 5-4 8-9 8s-9-3-9-8V7l9-4z" />
                    <path d="M9 12l2 2 4-4" />
                </svg>
                <span className="relative">Verify this battle</span>
            </Link>
            <p className="text-text_3 text-sm text-center leading-relaxed">
                More details on how our system works can be found on the{' '}
                <Link
                    href="/fairplay?game=casebattles"
                    className="text-accent border-b border-accent/30 hover:text-[#7be6ff] hover:border-accent/60 transition-colors"
                >
                    Provably Fair
                </Link>{' '}
                page.
            </p>
        </div>
    );
};

export default BattleFairness;
